<template>
  <div>
    <head>
      <!-- App favicon -->
      <link rel="shortcut icon" href="assets/images/favicon.svg">
      <link href="assets/libs/select2/css/select2.min.css" rel="stylesheet" type="text/css" />
      <link href="assets/libs/bootstrap-datepicker/css/bootstrap-datepicker.min.css" rel="stylesheet" type="text/css">
      <link href="assets/libs/spectrum-colorpicker2/spectrum.min.css" rel="stylesheet" type="text/css">
      <link href="assets/libs/bootstrap-timepicker/css/bootstrap-timepicker.min.css" rel="stylesheet" type="text/css">
      <link href="assets/libs/bootstrap-touchspin/jquery.bootstrap-touchspin.min.css" rel="stylesheet" type="text/css" />
      <link rel="stylesheet" href="assets/libs/%40chenfengyuan/datepicker/datepicker.min.css">
      <!-- Bootstrap Css -->
      <link href="assets/css/bootstrap.min.css" id="bootstrap-style" rel="stylesheet" type="text/css" />
      <!-- Bootstrap select styling -->
      <link rel="stylesheet" href="https://cdn.jsdelivr.net/npm/bootstrap-select@1.13.14/dist/css/bootstrap-select.min.css">
      <!-- Icons Css -->
      <link href="assets/css/icons.min.css" rel="stylesheet" type="text/css" />
      <!-- App Css-->
      <link href="assets/css/app.min.css" id="app-style" rel="stylesheet" type="text/css" />
      <!-- custom Css-->
      <link href="assets/css/custom.css" id="app-style" rel="stylesheet" type="text/css" />
    </head>

    <body @contextmenu.prevent data-sidebar="dark">
    <div id="layout-wrapper">
      <NavigationBar/>

      <!-- All Modal Components -->
      <CustomerSearchModal
          v-model:phone-number="phoneNumber"
          :message="message"
          @search-customer="getCustomer"
      />

      <CustomerRegistrationModal
          v-model:phone-number="phoneNumber"
          v-model:customer-name="customerName"
          v-model:email="email"
          :message="message"
          @register-customer="addCustomers"
      />

      <EditBillModal
          :bill-item="selectedBillItem"
          :income-types="billingModule.incomeTypes"
          :accounts="feesAndCharges"
          :sub-counties="subCounties"
          :wards="wards"
          @save-bill-item="handleBillItemSave"
      />

      <!-- Bill Generated Modal - Added payLater props -->
      <BillGeneratedModal
          :message="message"
          :bill-details="billDetails"
          :bill-info="billInfo"
          :bank="bank"
          :pay-bill="payBill"
          :county="county"
          :pay-later="payLater"
          :customer-phone="phoneNumber"
          :customer-email="email"
          @print-bill="printBill"
          @proceed-to-payment="handleProceedToPayment"
      />

      <!-- Existing Payment Modal -->
      <PaymentModal
          :message="message"
          :payment-panel="paymentPanel"
          :payment-method="paymentMethod"
          :transaction-summary="transactionSummary"
          :transaction-completed="transactionCompleted"
          v-model:phone-number="phoneNumber"
          :bill-details="billDetails"
          :payment-data="paymentData"
          :receipt-details="receiptDetails"
          :alert="alert"
          @show-payment-method="showPaymentMethod"
          @show-transaction-summary="showTransactionSummary"
          @make-payment="makePayment"
          @print-bill="printBill"
          @print-receipt="printReceipt"
          @update:bankReceiptNo="paymentData.bankReceiptNo = $event"
      />

      <FoodHygieneModal
          :application="foodHygieneApplication"
          :sub-counties="subCounties"
          :wards="wards"
          :message="message"
          @submit-application="handleFoodHygieneSubmit"
          @update:message="message = $event"
      />

      <FoodHandlerModal
          :applicant="foodHandlerApplicant"
          :sub-counties="subCounties"
          :wards="wards"
          :message="message"
          @submit-application="handleFoodHandlerSubmit"
          @update:message="message = $event"
      />

      <NewBusinessModal
          ref="newBusinessModal"
          :trade="trade"
          :sub-counties="subCounties"
          :wards="wards"
          :floors="trade.floors"
          :roles="roles"
          :years="years"
          :trade-categories="trade.tradeCategories"
          :trade-sub-categories="trade.tradeSubCategories"
          :trade-sub-categories-other="tradeSubCategoriesOther"
          :other-charge-categories="otherChargeCategories"
          :trade-all-other-fees="tradeAllOtherFees"
          :tonnage-options="trade.tonnage"
          :total-fee-amount-others="totalFeeAmountOthers"
          :penalized="penalized"
          :show-all-charges="showAllCharges"
          :message="message"
          @register-business="registerBusiness"
          @subcounty-changed="handleSubCountyChanged"
          @ward-changed="handleWardChanged"
          @category-changed="getTradeSubCategory"
          @subcategory-changed="selectedTradeSubCategory"
          @other-charge-selected="handleOtherChargeSelected"
          @other-category-selected="handleOtherCategorySelected"
          @other-charges-updated="handleOtherChargesUpdated"
          @penalty-changed="penalized = $event"
          @toggle-charges="toggleChargesView"
          @update:message="message = $event"
      />

      <LiquorLicenseModal
          :application="liquorApplication"
          :sub-counties="subCounties"
          :wards="wards"
          :message="message"
          @submit-application="handleLiquorSubmit"
          @update:message="message = $event"
      />

      <div id="content" class="content-minimize">
        <div class="page-content">
          <div class="container-fluid">
            <div class="row">
              <div class="col-12">
                <div class="page-title-box d-sm-flex align-items-center justify-content-between">
                  <h4 class="mb-sm-0 font-size-18 text-capitalize">
                    Create New Bill
                    <span v-if="$route && $route.query && $route.query.source === 'enforcement'"
                          class="badge bg-danger ms-2 align-middle">SBP Enforcement</span>
                  </h4>
                  <div class="page-title-right">
                    <button v-if="$route && $route.query && $route.query.source === 'enforcement'"
                            class="btn btn-sm btn-outline-secondary me-2"
                            @click="$router.push('/sbp-enforcement')">
                      <i class="bx bx-arrow-back"></i> Back to Enforcement
                    </button>
                    <ol class="breadcrumb m-0 d-inline-flex">
                      <li class="breadcrumb-item"><a href="index.html">Home</a></li>
                      <li class="breadcrumb-item active">New Bill</li>
                    </ol>
                  </div>
                </div>
              </div>
            </div>

            <div class="row">
              <div class="col-lg-12">
                <div class="card bill-creater-module">
                  <div class="card-body">
                    <div class="row">
                      <div class="col-12">
                        <div class="p-4 bg-light mb-4">
                          <div class="row d-flex justify-content-between align-items-center">
                            <div class="col-12 d-flex justify-content-between align-items-center">
                              <div class="d-fle">
                                <p class="mb-0 fw-semibold text-uppercase pb-0">
                                  <a href="javascript: void(0);">Client Details</a>
                                </p>
                              </div>
                              <div class="">
                                <div class="mb-0 d-flex justify-content-between align-items-center">
                                  <button class="btn btn-success btn-sm" data-toggle="modal" data-target="#subscribeModal">
                                    Select A different Client
                                  </button>
                                </div>
                              </div>
                            </div>
                            <div class="col-12"><hr></div>

                            <div class="col-12">
                              <div class="row">
                                <div class="col-4 col-sm-12 col-md-4">
                                  <div class="d-flex">
                                    <div class="flex-shrink-0 me-3 align-self-center">
                                      <i class="mdi mdi-account h2 text-dark"></i>
                                    </div>
                                    <div class="flex-grow-1">
                                      <p class="text-muted mb-0">Customer Name</p>
                                      <h5 class="mb-0 font-14px"><span>{{ customerName }}</span></h5>
                                    </div>
                                  </div>
                                </div>

                                <div class="col-4 col-sm-12 col-md-4">
                                  <div class="d-flex">
                                    <div class="flex-shrink-0 me-3 align-self-center">
                                      <i class="mdi mdi-phone h2 text-dark"></i>
                                    </div>
                                    <div class="flex-grow-1">
                                      <p class="text-muted mb-0">Phone No.</p>
                                      <h5 class="mb-0 font-14px text-uppercase"><span>{{ phoneNumber }}</span></h5>
                                    </div>
                                  </div>
                                </div>

                                <div class="col-4 col-sm-12 col-md-4">
                                  <div class="d-flex">
                                    <div class="flex-shrink-0 me-3 align-self-center">
                                      <i class="mdi mdi-email-outline h2 text-dark"></i>
                                    </div>
                                    <div class="flex-grow-1">
                                      <p class="text-muted mb-0">Email Address</p>
                                      <h5 class="mb-0 font-14px"><span>{{ email }}</span></h5>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>

                      <div class="col-sm-12 col-md-4 col-lg-5">
                        <div class="d-flex justify-items-center align-items-center">
                          <div class="border-1 invoice-form p-4">
                            <h4 class="card-title mb-4">Enter the invoice details below</h4>

                            <div v-if="message!==null" class="alert alert-danger" role="alert">
                              {{ message }}
                            </div>

                            <form>
                              <div class="row tenant-invoice-container invoice-options">
                                <!-- Enforcement mode: stream is locked to SBP, hide the picker -->
                                <div class="col-12" v-if="$route && $route.query && $route.query.source === 'enforcement'">
                                  <div class="alert alert-light border d-flex align-items-center mb-3">
                                    <i class="bx bx-lock-alt me-2 text-danger fs-4"></i>
                                    <div class="flex-grow-1">
                                      <strong>SBP Enforcement</strong> — invoicing is locked to Single Business Permit. Other revenue streams are not available from this page.
                                    </div>
                                  </div>
                                </div>

                                <!-- Normal mode: full stream picker -->
                                <div class="col-12" v-else>
                                  <div class="mb-3">
                                    <label for="formrow-firstname-input" class="form-label">Revenue Stream</label>
                                    <select @change="selectRevenue($event)" class="form-select" v-model="stream">
                                      <option :key="`${index}`" :value="item.incomeTypePrefix" v-for="(item, index) in streams">
                                        {{ item.stream }}
                                      </option>
                                    </select>
                                  </div>
                                </div>

                                <div class="col-12 rev-options-cont">
                                  <div class="row others-rev">
                                    <div class="col-6">
                                      <div class="mb-3">
                                        <label for="formrow-firstname-input" class="form-label">Income Type</label>
                                        <select @change="selectedIncomeType($event)" title="-- Income Type --" class="form-control show-tick" data-live-search="true" v-model="billingModule.incomeType">
                                          <option value="">Please Select</option>
                                          <option v-for="(item, index) in billingModule.incomeTypes" :value="JSON.stringify(item)" :key="index">
                                            {{ item.incomeTypeDescription }}
                                          </option>
                                        </select>
                                      </div>
                                    </div>

                                    <div class="col-6">
                                      <div class="mb-3">
                                        <label for="formrow-firstname-input" class="form-label">Account Name</label>
                                        <select @change="selectedFeeAndCharge($event)" class="form-control bg-white" title="Select Account" data-live-search="true">
                                          <option v-for="(item, index) in feesAndCharges" :value="JSON.stringify(item)" :key="index">
                                            {{ item.feeDescription }} KES {{ item.unitFeeAmount }}
                                          </option>
                                        </select>
                                      </div>
                                    </div>

                                    <div class="col-6">
                                      <div class="mb-3">
                                        <label for="formrow-firstname-input" class="form-label">Sub County</label>
                                        <select v-model="subCounty" class="form-control bg-white" title="Select Sub County" data-live-search="true">
                                          <option v-for="(item, index) in subCounties" :value="item" :key="index">
                                            {{ item.subCountyName }}
                                          </option>
                                        </select>
                                      </div>
                                    </div>

                                    <div class="col-6">
                                      <div class="mb-3">
                                        <label for="formrow-firstname-input" class="form-label">Ward</label>
                                        <select v-model="ward" class="form-control bg-white" title="Select Ward" data-live-search="true">
                                          <option v-for="(item, index) in wards" :value="item" :key="index">
                                            {{ item.wardName }}
                                          </option>
                                        </select>
                                      </div>
                                    </div>

                                    <div class="col-12">
                                      <div class="mb-3">
                                        <label for="formrow-firstname-input" class="form-label">Details</label>
                                        <textarea v-model="description" cols="30" rows="3" placeholder="More details" class="form-control"></textarea>
                                      </div>
                                    </div>

                                    <div class="col-md-6 col-sm-12 col-lg-5 mb-4">
                                      <div class="mb-3">
                                        <label for="formrow-email-input" class="form-label">Quantity.</label>
                                        <input v-model="quantity" type="text" class="form-control" placeholder="Quantity">
                                      </div>
                                    </div>

                                    <div class="col-md-6 col-sm-12 col-lg-5 mb-4">
                                      <div class="mb-3">
                                        <label for="formrow-email-input" class="form-label">Amount</label>
                                        <input v-model="amount" type="text" class="form-control" placeholder="Bill Item amount" readonly>
                                      </div>
                                    </div>

                                    <div>
                                      <button @click="addToBill(description)" type="button" class="btn btn-primary waves-effect btn-label waves-light">
                                        <i class="bx bx-plus label-icon"></i> Bill Item
                                      </button>
                                    </div>
                                  </div>

                                  <div class="row trade-rev d-none">
                                    <div class="col-12">
                                      <select @change="selectRevenue($event)" class="form-select mb-4">
                                        <option value="Register New Business">Register New Business</option>
                                        <option value="Renew License Business">Renew License</option>
                                      </select>
                                    </div>

                                    <div class="col-12">
                                      <div class="row">
                                        <div class="col-12 register-new-business">
                                          <button type="button" class="btn btn-outline-success waves-effect waves-light btn-soft w-100 p-4 text-uppercase" data-toggle="modal" data-target="#new-business">
                                            <i class="mdi-briefcase-plus-outline mdi d-block font-size-30"></i> Start New Business Registration
                                          </button>
                                        </div>

                                        <div class="col-12 d-none renew-business">
                                          <div class="mb-3">
                                            <label for="formrow-firstname-input" class="form-label">Business ID</label>
                                            <input v-model="businessID" type="text" class="form-control" placeholder="Enter Business ID to continue">
                                          </div>
                                          <div class="row">
                                            <div class="col-12">
                                              <div class="mb-3">
                                                <label for="formrow-firstname-input" class="form-label">Business Name</label>
                                                <input v-model="trade.businessDetails.businessName" type="text" class="form-control" disabled placeholder="Searched Business ...">
                                              </div>
                                            </div>
                                          </div>
                                          <div class="row">
                                            <div class="col-12">
                                              <button @click="addToBill(trade.businessDetails.businessName)" type="button" class="btn btn-info waves-effect btn-label waves-light w-100">
                                                <i class="dripicons-plus label-icon"></i> Add to Bill
                                              </button>
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                  </div>

                                  <div class="row health-rev d-none">
                                    <div class="col-6">
                                      <div class="mb-3">
                                        <label for="formrow-firstname-input" class="form-label">Select Service</label>
                                        <select class="form-select health-selector" title="Select Option" data-live-search="true">
                                          <option value="Food Hygien">Food Hygien</option>
                                          <option value="Food Handler">Food Handler</option>
                                        </select>
                                      </div>
                                    </div>

                                    <div class="col-6">
                                      <div class="mb-3">
                                        <label for="formrow-firstname-input" class="form-label">Select Option</label>
                                        <select class="form-select hyginene-selector" title="Select Option" data-live-search="true">
                                          <option value="New Application">New Application</option>
                                          <option value="Renewal">Renewal</option>
                                        </select>
                                        <select class="form-select handler-selector d-none" title="Select Option" data-live-search="true">
                                          <option value="New Application">New Application</option>
                                          <option value="Renewal">Renewal</option>
                                        </select>
                                      </div>
                                    </div>

                                    <div class="col-12 health-options">
                                      <div class="row food-hygiene-cont">
                                        <div class="col-12 new-hygiene">
                                          <button type="button" class="btn btn-outline-success waves-effect waves-light btn-soft w-100 p-4 text-uppercase" data-toggle="modal" data-target="#new-food-hygene">
                                            <i class="mdi-food-fork-drink mdi d-block font-size-30"></i> Start Food Hygiene Application
                                          </button>
                                        </div>
                                      </div>

                                      <div class="row food-handler-cont d-none">
                                        <div class="col-12 new-Handler">
                                          <button type="button" class="btn btn-outline-success waves-effect waves-light btn-soft w-100 p-4 text-uppercase" data-toggle="modal" data-target="#new-food-handler">
                                            <i class="mdi-chef-hat mdi d-block font-size-30"></i> Start Food Handler Application
                                          </button>
                                        </div>
                                      </div>
                                    </div>
                                  </div>

                                  <div class="row liquor-rev d-none">
                                    <div class="col-12">
                                      <div class="mb-3">
                                        <label for="formrow-firstname-input" class="form-label">Select Service</label>
                                        <select class="form-select liquor-selector" title="Select Option" data-live-search="true">
                                          <option value="New Application">Licence Application</option>
                                          <option value="License Renewal">Licence Renewal</option>
                                        </select>
                                      </div>
                                    </div>

                                    <div class="col-12 liqur-options">
                                      <div class="row">
                                        <div class="col-12 new-application">
                                          <button type="button" class="btn btn-outline-success waves-effect waves-light btn-soft w-100 p-4 text-uppercase" data-toggle="modal" data-target="#new-liquore-license">
                                            <i class="mdi-glass-mug-variant mdi d-block font-size-30"></i> Start Liquor License Application
                                          </button>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </form>
                          </div>
                        </div>
                      </div>

                      <div class="col-sm-12 col-md-8 col-lg-7">
                        <div class="d-flex justify-items-center align-items-center">
                          <div class="border-1 invoice-table p-4 w-100">
                            <h4 class="card-title mb-4">Created Bill Details</h4>
                            <div class="row">
                              <div class="col-12">
                                <div class="table-responsive border-1">
                                  <table class="table table-nowrap vertical-align-middle table-sm">
                                    <thead class="bg-light">
                                    <tr>
                                      <th style="width: 70px;">No.</th>
                                      <th>Details</th>
                                      <th class="text-end">Amount</th>
                                      <th class="" style="width: 150px;"></th>
                                    </tr>
                                    </thead>
                                    <tfoot class="bg-light">
                                    <tr>
                                      <td colspan="2" class="border-0 text-end text-right">
                                        <strong>Total</strong>
                                      </td>
                                      <td class="border-0 text-end">
                                        <h5 class="m-0 text-uppercase fw-bold">KES {{ numberFormat(totalAmount) }}</h5>
                                      </td>
                                      <td></td>
                                    </tr>
                                    </tfoot>
                                    <tbody v-for="(item,index) in billItem" :key="`item-${index}`">
                                    <tr>
                                      <td>{{ index + 1 }}</td>
                                      <td>
                                        <p class="the-bill-item mb-0 p-0 m-0">
                                          {{ item.incomeTypeId }} {{ item.feeDescription }}
                                        </p>
                                      </td>
                                      <td class="text-end">KES {{ numberFormat(item.unitFeeAmount) }} (x {{ item.quantity }})</td>
                                      <td class="text-right">
                                        <button title="Remove Item" @click="selectedIndex(item,index)" type="button" class="btn btn-link waves-effect text-danger">
                                          <i class="mdi mdi-close font-size-16 align-middle me-2"></i>
                                        </button>
                                      </td>
                                    </tr>
                                    </tbody>
                                  </table>
                                </div>
                              </div>
                            </div>

                            <!-- ✅ NEW: Pay Later Toggle -->
                            <div class="mb-3 mt-3 p-3 bg-light rounded">
                              <div class="form-check form-switch">
                                <input
                                    class="form-check-input"
                                    type="checkbox"
                                    id="payLaterSwitch"
                                    v-model="payLater"
                                    style="width: 3rem; height: 1.5rem;"
                                >
                                <label class="form-check-label ms-2 pt-1" for="payLaterSwitch">
                                  <span v-if="!payLater" class="fw-semibold text-success">
                                    <i class="mdi mdi-cash-fast me-1"></i> Pay Now
                                  </span>
                                  <span v-else class="fw-semibold text-warning">
                                    <i class="mdi mdi-clock-outline me-1"></i> Pay Later
                                    <small class="text-muted ms-2">(SMS & Email will be sent to customer)</small>
                                  </span>
                                </label>
                              </div>
                            </div>

                            <button @click="generateBill()" type="button" class="btn btn-success waves-effect btn-label waves-light">
                              <i class="bx bx-plus label-icon"></i> Create Bill
                            </button>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <footer class="footer">
          <div class="container-fluid">
            <div class="row">
              <div class="col-sm-6"></div>
              <div class="col-sm-6">
                <div class="text-sm-end d-sm-block">
                  A product of county
                </div>
              </div>
            </div>
          </div>
        </footer>
      </div>
    </div>

    <div class="rightbar-overlay"></div>
    </body>
  </div>
</template>

<script>
/* eslint-disable */
import NavigationBar from "@/components/Navigation.vue";
import { execute, biller, rent, parking, trade, authUrl } from "@/api";
import $ from 'jquery'

import CustomerSearchModal from '@/components/modals/BillModals/CustomerSearchModal.vue'
import CustomerRegistrationModal from '@/components/modals/BillModals/CustomerRegistrationModal.vue'
import EditBillModal from '@/components/modals/BillModals/EditBillModal.vue'
import PaymentModal from '@/components/modals/BillModals/PaymentModal.vue'
import BillGeneratedModal from '@/components/modals/BillModals/BillGeneratedModal.vue'
import FoodHygieneModal from '@/components/modals/HealthModals/FoodHygieneModal.vue'
import FoodHandlerModal from '@/components/modals/HealthModals/FoodHandlerModal.vue'
import NewBusinessModal from '@/components/modals/TradeModals/NewBusinessModal.vue'
import LiquorLicenseModal from '@/components/modals/TradeModals/LiquorLicenseModal.vue'

export default {
  name: "BillNew",

  components: {
    NavigationBar,
    CustomerSearchModal,
    CustomerRegistrationModal,
    EditBillModal,
    PaymentModal,
    BillGeneratedModal,
    FoodHygieneModal,
    FoodHandlerModal,
    NewBusinessModal,
    LiquorLicenseModal
  },

  data() {
    return {
      currentPage: 1,
      totalPages: 0,
      pageSize: 10,

      alert: {
        success: false,
        info: false,
        failed: false
      },

      penalized: false,
      payLater: false, // ✅ NEW: Pay Later toggle - when true, sends SMS & Email

      tradeSubCategoriesOther: [],
      otherChargeCategories: [],
      // Flat list of every fee across every SBP-Other income type — populated
      // by getTradeCategoryOther after income types arrive. Mirrors the Android
      // Enforcement-craft "loadFeesAsCheckboxes" experience: officer picks any
      // fee without first selecting a category.
      tradeAllOtherFees: [],
      checkedItems: [],
      totalFeeAmountOthers: 0,
      showAllCharges: false,

      zone: '',
      feeID: '',
      plotNO: '',
      fiscalYear: '',
      quantity: 1,

      phoneNumber: '',
      customerName: '',
      email: '',
      message: null,

      transactionCompleted: false,
      transactionSummary: false,
      paymentPanel: true,
      paymentMethod: false,

      billDetails: {
        id: '',
        billNo: '',
        incomeTypeID: '',
        incomeTypeDescription: '',
        costCenterNo: '',
        accountNo: '',
        feeID: '',
        detailAmount: '',
        receiptAmount: '',
        billBalance: '',
        wardID: '',
        subCountyID: '',
        status: '',
        dateCreated: '',
        printable: 'false',
        customerName: '',
        customerPhoneNumber: '',
        subCountyName: '',
        wardName: '',
        names: '',
        description: ''
      },

      billInfo: [],
      briefDescription: '',

      bank: {
        id: null,
        bankID: null,
        bank: '',
        payBill: '',
        format: '',
        bankType: '',
        accountNo: null,
        company: ''
      },

      payBill: {
        id: null,
        stream: '',
        shortCode: ''
      },

      county: {
        id: null,
        countyID: '',
        countyName: '',
        countyNameFull: '',
        tagline: '',
        contact: '',
        email: '',
        logo: '',
        stateLogo: '',
        signature: '',
        poweredByLogo: ''
      },

      subCounty: {
        subCountyID: null,
        subCountyName: null
      },

      ward: {
        wardID: null,
        wardName: null
      },

      selectedBillItem: {},
      itemIndex: '',
      description: '',
      amount: 0,
      unitFeeAmount: 0,

      subCounties: [],
      wards: [],
      billItem: [],
      feesAndChargeItems: [],
      feesAndCharges: [],
      totalAmount: 0,

      paymentData: {
        bankReceiptNo: null,
        accNo: null,
        payBillNo: null,
        amount: null,
        phoneNumber: null,
        success: false,
        paymentMode: null,
        sessionNames: null,
        sessionIdNo: null,
        sessionPhoneNumber: null
      },

      timer: null,
      paymentCheckStartTime: null,
      paymentTimeoutDuration: 35000,
      isCheckingPayment: false,

      receiptDetails: {
        id: '',
        receiptNo: null,
        billNo: '',
        detailAmount: '',
        receiptAmount: '',
        billBalance: '',
        costCenterNo: '',
        accountNo: '',
        incomeTypeDescription: '',
        feeID: '',
        wardID: '',
        subCountyID: '',
        currency: '',
        source: '',
        transactionCode: '',
        paidBy: '',
        dateCreated: '',
        dateModified: '',
        createdBy: '',
        modifiedBy: '',
        isActive: '',
        status: ''
      },

      billingModule: {
        incomeType: {
          incomeTypeId: null,
          incomeTypeDescription: null,
          incomeTypePrefix: null,
          fundDescription: null,
          status: null
        },
        incomeTypes: []
      },

      selectedStream: 'Others',

      businessID: null,
      trade: {
        fiscalYear: '',
        amount: null,
        tonnage: [],
        floors: [],
        tradeCategories: [],
        tradeSubCategories: [],
        businessDetails: {
          id: null,
          businessID: null,
          businessName: null,
          subCountyID: null,
          subCountyName: null,
          wardID: null,
          wardName: null,
          plotNumber: null,
          physicalAddress: null,
          buildingName: null,
          buildingOccupancy: null,
          floorNo: null,
          roomNo: null,
          premiseSize: null,
          numberOfEmployees: null,
          tonnage: null,
          businessDes: null,
          businessCategory: null,
          businessSubCategory: null,
          incomeTypeID: null,
          feeID: null,
          businessEmail: null,
          postalAddress: null,
          postalCode: null,
          businessPhone: null,
          contactPersonNames: null,
          contactPersonIDNo: null,
          businessRole: null,
          contactPersonPhone: null,
          contactPersonEmail: null,
          fullNames: null,
          ownerID: null,
          ownerPhone: null,
          ownerEmail: null,
          kraPin: null,
          createdBy: null,
          createdByIDNo: null,
          dateCreated: null,
          lat: 0.0,
          lng: 0.0
        }
      },

      streams: [],
      roles: [],
      years: [],

      foodHygieneApplication: {
        businessID: '',
        businessName: '',
        pinNumber: '',
        plotNumber: '',
        phoneNumber: '',
        email: '',
        poBox: '',
        town: '',
        subCountyID: '',
        wardID: '',
        status: 'approved'
      },

      foodHandlerApplicant: {
        firstName: '',
        otherNames: '',
        idNumber: '',
        phoneNumber: '',
        email: '',
        gender: 'Male',
        subCountyID: '',
        wardID: ''
      },

      liquorApplication: {
        businessID: '',
        businessName: '',
        kraPin: '',
        plotNumber: '',
        phoneNumber: '',
        email: '',
        poBox: '',
        town: '',
        physicalAddress: '',
        subCountyID: '',
        wardID: '',
        status: 'approved'
      },

      stream: '',
      ReconTransactions: []
    }
  },

  beforeUnmount() {
    this.stopPaymentCheck();
  },

  watch: {
    'paymentData.bankReceiptNo': function(newVal, oldVal) {
      if (newVal !== '') {
        this.getReconciledRecords(newVal)
      }
    },

    subCounty: {
      handler: function(newVal) {
        if (!newVal || !newVal.subCountyID) return;

        this.wards = []
        this.ward = {
          wardID: null,
          wardName: null
        }

        this.trade.businessDetails.subCountyName = newVal.subCountyName
        this.trade.businessDetails.subCountyID = newVal.subCountyID

        this.getWards()
      },
      deep: true
    },

    ward: {
      handler: function(newVal) {
        if (!newVal || !newVal.wardID) return;

        this.trade.businessDetails.wardName = newVal.wardName
        this.trade.businessDetails.wardID = newVal.wardID
      },
      deep: true
    },

    businessID: function() {
      if (this.businessID !== null && this.businessID !== "") {
        this.getBusiness(true)
      }
    },

    quantity: function() {
      this.amount = this.quantity * this.unitFeeAmount;
      this.feesAndChargeItems = this.feesAndChargeItems.map(item => {
        if (item.feeId === this.feeID) {
          item.quantity = this.quantity;
        }
        return item;
      });
    },

    checkedItems(newCheckedItems) {
      this.totalFeeAmountOthers = newCheckedItems.reduce((sum, item) => sum + parseFloat(item.unitFeeAmount || 0), 0);
    }
  },

  mounted() {
    this.zone = sessionStorage.getItem("sessionZone")
    this.getMainStreams()
    this.getYears()
    this.getSubCounties()
    this.getFloor()
    this.getTonnage()
    this.getRoles()
    this.menuAccess()
    this.getTradeCategoryOther()

    var button = document.querySelector(".btn.btn-success.btn-sm");
    if (button) {
      button.click();
    }

    // Enforcement mode: officer arrived from /sbp-enforcement and should
    // only invoice SBP. Lock the stream selector to SBP and skip the
    // "Choose a stream" step entirely.
    if (this.$route && this.$route.query && this.$route.query.source === 'enforcement') {
      this.stream = 'SBP';
      this.selectedStream = 'SBP';
      this.$nextTick(() => {
        this.selectRevenue({ target: { value: 'SBP' } });
      });
    }
  },

  methods: {
    // Modal Utility Functions
    openModal(modalId) {
      const modalEl = document.getElementById(modalId);
      if (!modalEl) {
        console.error(`Modal with id "${modalId}" not found`);
        return;
      }

      if (typeof bootstrap !== 'undefined' && bootstrap.Modal) {
        const modal = new bootstrap.Modal(modalEl);
        modal.show();
        return;
      }

      if (typeof $ !== 'undefined' && $.fn && $.fn.modal) {
        $(modalEl).modal('show');
        return;
      }

      modalEl.classList.add('show');
      modalEl.style.display = 'block';
      modalEl.setAttribute('aria-modal', 'true');
      modalEl.removeAttribute('aria-hidden');
      document.body.classList.add('modal-open');

      const backdrop = document.createElement('div');
      backdrop.className = 'modal-backdrop fade show';
      document.body.appendChild(backdrop);
    },

    closeModal(modalId) {
      const modalEl = document.getElementById(modalId);
      if (!modalEl) {
        console.error(`Modal with id "${modalId}" not found`);
        return;
      }

      if (typeof bootstrap !== 'undefined' && bootstrap.Modal) {
        const modalInstance = bootstrap.Modal.getInstance(modalEl);
        if (modalInstance) {
          modalInstance.hide();
        }
        return;
      }

      if (typeof $ !== 'undefined' && $.fn && $.fn.modal) {
        $(modalEl).modal('hide');
        return;
      }

      modalEl.classList.remove('show');
      modalEl.style.display = 'none';
      modalEl.setAttribute('aria-hidden', 'true');
      modalEl.removeAttribute('aria-modal');
      document.body.classList.remove('modal-open');

      const backdrop = document.querySelector('.modal-backdrop');
      if (backdrop) {
        backdrop.remove();
      }
    },

    numberFormat(num) {
      const britishNumberFormatter = new Intl.NumberFormat("en-GB");
      return britishNumberFormatter.format(num)
    },

    menuAccess() {
      const data = new FormData();
      data.append("function", "menuAccess");
      data.append("menu", "New Bill");
      data.append("sessionNames", sessionStorage.getItem("sessionNames"));
      data.append("sessionIdNo", sessionStorage.getItem("sessionIdNo"));
      execute(data, biller).then(() => {}).catch(() => {});
    },

    getCustomer(phoneNumber) {
      const phone = phoneNumber || this.phoneNumber;

      if (phone == '' || phone == null) {
        this.message = "Please enter phone number"
        return
      }

      this.message = null;

      const data = new FormData();
      data.append("function", "getCustomer");
      data.append("phoneNumber", phone);
      execute(data, biller)
          .then((res) => {
            if (res.data.success) {
              this.email = res.data.data.customer.email
              this.customerName = res.data.data.customer.names
              this.phoneNumber = phone;

              var button = document.querySelector("#closeModalSearch");
              if (button) {
                button.click();
              }

              this.message = null
            } else {
              this.message = res.data.message
            }
          })
          .catch((e) => {
            this.message = e.message
          });
    },

    addCustomers(customerData) {
      const phoneNumber = customerData?.phoneNumber || this.phoneNumber;
      const customerName = customerData?.customerName || this.customerName;
      const email = customerData?.email || this.email;

      if (phoneNumber === '') {
        this.message = "Please Enter customer phone number"
        return
      }
      if (customerName === '') {
        this.message = "Please Enter customer name"
        return
      }

      const data = new FormData();
      data.append("function", "addCustomers");
      data.append("phoneNumber", phoneNumber);
      data.append("email", email);
      data.append("names", customerName);
      data.append("createdBy", sessionStorage.getItem("sessionNames"));
      execute(data, biller)
          .then((res) => {
            if (res.data.success) {
              var button = document.querySelector("#closeAddCustomerModal");
              if (button) {
                button.click();
              }
              this.message = null
            } else {
              this.message = res.data.message
            }
          })
          .catch((e) => {
            this.message = e.message
          });
    },

    handleBillItemSave(item) {
      console.log('Bill item saved:', item)
    },

    handleFoodHygieneSubmit(application) {
      const data = new FormData();
      data.append("function", "submitFoodHygiene");
      data.append("application", JSON.stringify(application));

      execute(data, biller)
          .then((res) => {
            if (res.data.success) {
              $('#new-food-hygene').modal('hide');
              this.message = "Food Hygiene application submitted successfully";
              setTimeout(() => { this.message = null }, 3000);
            } else {
              this.message = res.data.message;
            }
          })
          .catch((e) => {
            this.message = e.message;
          });
    },

    handleFoodHandlerSubmit(applicant) {
      const data = new FormData();
      data.append("function", "submitFoodHandler");
      data.append("applicant", JSON.stringify(applicant));

      execute(data, biller)
          .then((res) => {
            if (res.data.success) {
              $('#new-food-handler').modal('hide');
              this.message = "Food Handler application submitted successfully";
              setTimeout(() => { this.message = null }, 3000);
            } else {
              this.message = res.data.message;
            }
          })
          .catch((e) => {
            this.message = e.message;
          });
    },

    handleLiquorSubmit(application) {
      const data = new FormData();
      data.append("function", "submitLiquorLicense");
      data.append("application", JSON.stringify(application));

      execute(data, biller)
          .then((res) => {
            if (res.data.success) {
              $('#new-liquore-license').modal('hide');
              this.message = "Liquor License application submitted successfully";
              setTimeout(() => { this.message = null }, 3000);
            } else {
              this.message = res.data.message;
            }
          })
          .catch((e) => {
            this.message = e.message;
          });
    },

    handleOtherChargeSelected({ checked, item }) {
      if (checked) {
        this.checkedItems.push(item)
      } else {
        const index = this.checkedItems.findIndex(i => i.feeId === item.feeId)
        if (index > -1) {
          this.checkedItems.splice(index, 1)
        }
      }
    },

    handleSubCountyChanged(subCountyData) {
      this.subCounty = {
        subCountyID: subCountyData.subCountyID,
        subCountyName: subCountyData.subCountyName
      };

      this.getWards(subCountyData);
    },

    handleWardChanged(wardData) {
      this.ward = {
        wardID: wardData.wardID,
        wardName: wardData.wardName
      };
    },

    registerBusiness(tradeData) {
      if (!tradeData.fiscalYear || tradeData.fiscalYear === '') {
        this.message = "Fiscal year is required. Please select a year.";
        return;
      }

      if (tradeData.businessDetails.subCountyID && tradeData.businessDetails.subCountyName) {
        this.subCounty.subCountyID = tradeData.businessDetails.subCountyID;
        this.subCounty.subCountyName = tradeData.businessDetails.subCountyName;
      }

      if (tradeData.businessDetails.wardID && tradeData.businessDetails.wardName) {
        this.ward.wardID = tradeData.businessDetails.wardID;
        this.ward.wardName = tradeData.businessDetails.wardName;
      }

      this.trade.fiscalYear = tradeData.fiscalYear;
      this.trade.businessDetails = { ...tradeData.businessDetails };

      const data = new FormData();
      data.append("function", "registerBusiness");
      data.append("business", JSON.stringify(tradeData.businessDetails));
      data.append("idNo", sessionStorage.getItem("idNo"));

      if (tradeData.addedCharges && tradeData.addedCharges.length > 0) {
        data.append("additionalCharges", JSON.stringify(tradeData.addedCharges));
      }

      data.append("fiscalYear", tradeData.fiscalYear);

      execute(data, trade)
          .then((res) => {
            if (res.data.success) {
              const modalComponent = this.$refs.newBusinessModal;

              try {
                const modal = document.getElementById('new-business');
                if (modal) {
                  const bsModal = bootstrap.Modal.getInstance(modal);
                  if (bsModal) {
                    bsModal.hide();
                  } else {
                    modal.classList.remove('show');
                    modal.style.display = 'none';
                    modal.setAttribute('aria-hidden', 'true');
                    modal.removeAttribute('aria-modal');
                  }

                  setTimeout(() => {
                    const backdrops = document.querySelectorAll('.modal-backdrop');
                    backdrops.forEach(backdrop => backdrop.remove());
                    document.body.classList.remove('modal-open');
                    document.body.style.overflow = '';
                    document.body.style.paddingRight = '';

                    if (modalComponent && typeof modalComponent.resetForm === 'function') {
                      modalComponent.resetForm();
                    }
                  }, 300);
                }
              } catch (error) {
                console.error("Error closing modal:", error);
              }

              this.businessID = res.data.data.business.businessID;

              const addedCharges = tradeData.addedCharges || [];
              this.getBusiness(false, addedCharges);
              this.message = null;
            } else {
              this.message = res.data.message;
            }
          })
          .catch((e) => {
            this.message = "Error: " + e.message;
          });
    },

    getBusiness(renewal, addedCharges = []) {
      const data = new FormData();
      data.append("function", "getBusiness");
      data.append("businessID", this.businessID);

      execute(data, trade)
          .then((res) => {
            if (res.data.success) {
              this.feesAndChargeItems.splice(0)
              this.trade.businessDetails = res.data.data.business

              if (this.trade.businessDetails.lat) {
                this.trade.businessDetails.lat = parseFloat(this.trade.businessDetails.lat) || 0;
              }
              if (this.trade.businessDetails.lng) {
                this.trade.businessDetails.lng = parseFloat(this.trade.businessDetails.lng) || 0;
              }

              this.subCounty.subCountyID = this.trade.businessDetails.subCountyID
              this.subCounty.subCountyName = this.trade.businessDetails.subCountyName
              this.ward.wardID = this.trade.businessDetails.wardID
              this.ward.wardName = this.trade.businessDetails.wardName

              this.feesAndChargeItems = res.data.data.feesAndCharges;

              this.feesAndChargeItems = this.feesAndChargeItems.map(item => {
                if (item.feeId === this.trade.businessDetails.feeID) {
                  item.customer = "Business ID: " + this.trade.businessDetails.businessID;
                  item.quantity = this.quantity;
                } else {
                  item.customer = "";
                }
                return item;
              });

              if (addedCharges && addedCharges.length > 0) {
                addedCharges.forEach(addedCharge => {
                  const existingIndex = this.feesAndChargeItems.findIndex(
                      item => item.feeId === addedCharge.feeId
                  );

                  if (existingIndex !== -1) {
                    this.feesAndChargeItems[existingIndex].quantity = addedCharge.quantity;
                  } else {
                    this.feesAndChargeItems.push({
                      ...addedCharge,
                      customer: "",
                      quantity: addedCharge.quantity
                    });
                  }
                });
              }

              if (this.checkedItems && this.checkedItems.length > 0) {
                this.feesAndChargeItems = [
                  ...this.feesAndChargeItems,
                  ...this.checkedItems.filter(checkedItem =>
                      !this.feesAndChargeItems.some(feeItem => feeItem.feeId === checkedItem.feeId)
                  ).map(checkedItem => ({
                    ...checkedItem,
                    quantity: checkedItem.quantity || 1
                  }))
                ];
              }

              if (!renewal) {
                this.customerName = this.trade.businessDetails.businessName
                this.addToBill(this.trade.businessDetails.businessName)
              }
            } else {
              this.message = res.data.message
            }
          })
          .catch((e) => {
            this.message = e.message
          });
    },

    selectedFeeAndCharge(event) {
      const data = JSON.parse(event.target.value)
      this.feeID = data.feeId
      this.unitFeeAmount = data.unitFeeAmount
      this.feesAndChargeItems = []
      this.feesAndChargeItems.push(data)

      this.amount = this.quantity * this.unitFeeAmount;
      this.feesAndChargeItems = this.feesAndChargeItems.map(item => {
        if (item.feeId === this.feeID) {
          item.quantity = this.quantity;
        }
        return item;
      });
    },

    selectedIncomeType(event) {
      const value = event.target.value
      const result = JSON.parse(value);
      this.getFeesAndChargesBilling(result.incomeTypeId)
    },

    getIncomeTypes(incomeTypePrefix) {
      this.message = null
      this.billingModule.incomeTypes.splice(0)
      this.feesAndCharges.splice(0)
      const data = new FormData();
      data.append("function", "getIncomeTypes");
      if (incomeTypePrefix) {
        data.append("incomeTypePrefix", incomeTypePrefix);
      }
      execute(data, biller)
          .then((res) => {
            if (res.data.success) {
              this.billingModule.incomeTypes = res.data.data.incomeTypes
            } else {
              this.message = res.data.message
            }
          })
          .catch((e) => {
            this.message = e.message
          });
    },

    getFeesAndChargesBilling(incomeTypeId) {
      this.message = null
      this.feesAndCharges.splice(0)
      const data = new FormData();
      data.append("function", "getFeesAndCharges");
      data.append("incomeTypeId", incomeTypeId);
      execute(data, biller)
          .then((res) => {
            if (res.data.success) {
              this.feesAndCharges = res.data.data.feesAndCharges
            } else {
              this.message = res.data.message
            }
          })
          .catch((e) => {
            this.message = e.message
          });
    },

    selectedIndex(item, itemIndex) {
      this.selectedBillItem = item
      this.itemIndex = itemIndex
      this.removeFromBill()
    },

    removeFromBill() {
      this.billItem.splice(this.itemIndex, 1)
      this.totalAmount = this.billItem.reduce((total, item) => total + (Number(item.unitFeeAmount) * Number(item.quantity)), 0);
    },

    selectRevenue(event) {
      this.selectedStream = event.target.value

      if (this.selectedStream === "Others") {
        $('.others-rev').removeClass("d-none").siblings().addClass('d-none')
        this.getIncomeTypes()
        this.getSubCounties()
      } else if (this.selectedStream === "SBP") {
        $('.trade-rev').removeClass("d-none").siblings().addClass('d-none')
        this.getSubCounties()
        this.getTradeCategory()
      } else if (this.selectedStream === "Register New Business") {
        $('.register-new-business').removeClass("d-none").siblings().addClass('d-none')
      } else if (this.selectedStream === "Renew License Business") {
        $('.renew-business').removeClass("d-none").siblings().addClass('d-none')
      } else if (this.selectedStream === "HEALTH") {
        $('.health-rev').removeClass("d-none").siblings().addClass('d-none')
      } else if (this.selectedStream === "Liquor") {
        $('.liquor-rev').removeClass("d-none").siblings().addClass('d-none')
      } else {
        $('.others-rev').removeClass("d-none").siblings().addClass('d-none')
        this.getIncomeTypes(event.target.value)
      }
    },

    getSubCounties() {
      const data = new FormData();
      data.append("function", "getSubCounty");
      execute(data, biller)
          .then((res) => {
            if (res.data.success) {
              this.subCounties = res.data.data.subCounties
            } else {
              this.message = res.data.message
            }
          })
          .catch((e) => {
            this.message = e.message
          });
    },

    getWards(subCountyData) {
      this.wards = []
      this.ward = ''

      const subCountyID = subCountyData?.subCountyID || this.subCounty.subCountyID;

      if (!subCountyID) {
        return;
      }

      const data = new FormData();
      data.append("function", "getWards");
      data.append("subCountyID", subCountyID);
      execute(data, biller)
          .then((res) => {
            if (res.data.success) {
              this.wards = res.data.data.wards
            } else {
              this.message = res.data.message
            }
          })
          .catch((e) => {
            this.message = e.message
          });
    },

    getMainStreams() {
      const data = new FormData();
      data.append('function', 'getMainStreams');
      execute(data, biller)
          .then((res) => {
            if (res.data.success) {
              this.streams.splice(0);
              this.streams = res.data.data.streams;
            } else {
              this.message = res.data.message;
            }
          })
          .catch((e) => {
            this.message = e.message;
          });
    },

    addToBill(revenueStreamItem) {
      if (!this.feesAndChargeItems || this.feesAndChargeItems.length === 0) {
        return;
      }

      for (const { typeDescription, feeId, feeDescription, unitFeeAmount, accountNo, costCenterNo, incomeTypeId, customer, quantity } of this.feesAndChargeItems) {

        const itemQuantity = quantity || 1;

        const billItemToAdd = {
          fiscalYear: this.trade.fiscalYear || this.fiscalYear,
          typeDescription,
          feeDescription,
          quantity: itemQuantity,
          unitFeeAmount: unitFeeAmount,
          accountNo,
          costCenterNo,
          incomeTypeId,
          revenueStreamItem: revenueStreamItem,
          feeId,
          amount: unitFeeAmount * itemQuantity,
          customer: customer || '',
          zone: this.zone,
          subCountyID: this.subCounty.subCountyID,
          subCountyName: this.subCounty.subCountyName,
          wardID: this.ward.wardID,
          wardName: this.ward.wardName,
          idNo: sessionStorage.getItem("sessionIdNo"),
          phoneNumber: sessionStorage.getItem("sessionPhoneNumber"),
          names: sessionStorage.getItem("sessionNames"),
          customerPhoneNumber: this.phoneNumber,
          description: this.description,
          customerName: this.customerName
        };

        this.billItem.push(billItemToAdd);
      }

      this.totalAmount = this.billItem.reduce((total, item) => total + (Number(item.unitFeeAmount) * Number(item.quantity)), 0);
    },

    // ✅ UPDATED: generateBill now sends payNow parameter based on payLater toggle
    generateBill() {
      this.paymentMethod = false;
      this.paymentPanel = true;
      this.transactionSummary = false;
      this.transactionCompleted = false;
      this.message = "Generating Bill...please wait...";

      const data = new FormData();
      data.append("function", "generateBill3");
      data.append("penalized", this.penalized);
      data.append("billItem", JSON.stringify(this.billItem));

      // ✅ NEW: Pay Later sends payNow = "false" to trigger SMS & Email
      // Pay Now sends payNow = "true" (no notifications sent)
      data.append("payNow", this.payLater ? "false" : "true");

      // ✅ NEW: Add customer contact details when Pay Later is selected
      if (this.payLater) {
        data.append("customerPhoneNumber", this.phoneNumber || "");
        data.append("email", this.email || "");
      }

      execute(data, biller)
          .then((res) => {
            this.message = res.data.message;

            if (res.data.success) {
              this.penalized = false;

              this.billDetails = res.data.data.bill.billDetails;
              this.billInfo = res.data.data.bill.billInfo;
              this.bank = res.data.data.bill.bank || this.bank;
              this.payBill = res.data.data.bill.payBill || this.payBill;
              this.county = res.data.data.bill.county || this.county;

              this.paymentData.amount = res.data.data.bill.billDetails.billBalance;
              this.paymentData.accNo = res.data.data.bill.billDetails.billNo;
              this.paymentData.payBillNo = res.data.data.billGenerated.payBillNo;
              this.paymentData.sessionPhoneNumber = sessionStorage.getItem("sessionPhoneNumber");
              this.paymentData.sessionNames = sessionStorage.getItem("sessionNames");
              this.paymentData.sessionIdNo = sessionStorage.getItem("sessionIdNo");

              // Always open modal (user can print)
              this.$nextTick(() => {
                this.openModal('bill-generated-modal');
              });

              // If this bill was created from the SBP Enforcement page
              // (?source=enforcement), tag it in countyTrade so it shows
              // in the enforcement team's "Issued Invoices" report.
              if (this.$route && this.$route.query && this.$route.query.source === 'enforcement') {
                this.recordEnforcementInvoice();
              }

            } else {
              this.message = res.data.message;
            }
          })
          .catch((e) => {
            this.message = e.message;
          });
    },

    recordEnforcementInvoice() {
      try {
        const bd = this.billDetails || {};
        const bi = (this.billInfo && this.billInfo[0]) || {};
        const data = new FormData();
        data.append("function", "recordEnforcementInvoice");
        data.append("billNo", bd.billNo || '');
        data.append("businessID", this.businessID || '');
        data.append("businessName", (this.trade && this.trade.businessDetails && this.trade.businessDetails.businessName) || bi.customer || '');
        data.append("customerPhone", this.phoneNumber || (bd.customerPhoneNumber || ''));
        data.append("amount", bd.billBalance || bd.detailAmount || 0);
        data.append("subCountyName", bd.subCountyName || (this.subCounty && this.subCounty.subCountyName) || '');
        data.append("wardName", bd.wardName || (this.ward && this.ward.wardName) || '');
        data.append("inspectionID", (this.$route && this.$route.query && this.$route.query.inspectionID) || '');
        data.append("sessionNames", sessionStorage.getItem("sessionNames") || '');
        data.append("sessionIdNo", sessionStorage.getItem("sessionIdNo") || '');
        execute(data, biller).catch((e) => {
          // Non-blocking — bill itself was created. Just log.
          console.error("recordEnforcementInvoice failed", e);
        });
      } catch (err) {
        console.error("recordEnforcementInvoice setup failed", err);
      }
    },

    handleProceedToPayment() {
      if (this.billDetails.printable === 'false') {
        alert('This invoice must be approved before payment can be processed.');
        return;
      }

      this.closeModal('bill-generated-modal');

      setTimeout(() => {
        this.paymentPanel = false;
        this.paymentMethod = true;
        this.transactionSummary = false;
        this.transactionCompleted = false;

        this.openModal('payment-modal');
      }, 400);
    },

    printBill() {
      if (this.billDetails.printable === 'false') {
        alert('This invoice must be approved before it can be printed.');
        return;
      }

      localStorage['params'] = JSON.stringify({
        billNo: this.billDetails.billNo
      });

      const routeData = this.$router.resolve({ name: 'bill' });
      window.open(routeData.href, '_blank');
    },

    printReceipt() {
      if (this.receiptDetails.receiptNo == null) {
        alert("Try again later");
      } else {
        localStorage['params'] = JSON.stringify({
          receiptNo: this.receiptDetails.receiptNo
        })
        const routeData = this.$router.resolve({ name: 'receipt' });
        window.open(routeData.href, '_blank');
      }
    },

    showPaymentMethod() {
      this.paymentMethod = true;
      this.paymentPanel = false;
      this.transactionSummary = false;
      this.transactionCompleted = false
    },

    showTransactionSummary(paymentMode) {
      this.paymentData.paymentMode = paymentMode

      if (paymentMode === "MPESA") {
        if (this.phoneNumber == null) {
          alert("Enter phone number");
          return;
        }
      }
      if (paymentMode === "BANK") {
        if (this.paymentData.bankReceiptNo == null) {
          alert("Enter Bank Receipt No");
          return;
        }
      }

      this.paymentMethod = false;
      this.paymentPanel = false;
      this.transactionSummary = true;
      this.transactionCompleted = false
    },

    makePayment() {
      if (this.paymentData.paymentMode === "MPESA") {
        if (this.phoneNumber == null) {
          alert("Enter phone number");
          return;
        }
      }
      if (this.paymentData.paymentMode === "BANK") {
        if (this.paymentData.bankReceiptNo == null) {
          alert("Enter Bank Receipt No");
          return;
        }
      }

      this.message = "Payment Request sent";
      this.paymentData.phoneNumber = this.phoneNumber;

      const data = new FormData();
      data.append("function", "makePayment");
      data.append("paymentData", JSON.stringify(this.paymentData));

      let stream = null;
      if (this.paymentData.accNo.startsWith("SBP")) {
        stream = trade;
      }
      if (this.paymentData.accNo.startsWith("PKN")) {
        stream = parking;
      }
      if (this.paymentData.accNo.startsWith("RNT")) {
        stream = rent;
      }
      if (this.paymentData.accNo.startsWith("BLL")) {
        stream = biller;
      }

      execute(data, stream)
          .then((res) => {
            if (res.data.success) {
              this.paymentMethod = false;
              this.paymentPanel = false;
              this.startPaymentCheck();
            } else {
              this.rate = null;
              alert(res.data.message);
            }
          })
          .catch((e) => {
            alert(e.message);
          });
    },

    startPaymentCheck() {
      this.stopPaymentCheck();
      this.paymentCheckStartTime = Date.now();
      this.isCheckingPayment = true;

      this.timer = setInterval(() => {
        this.checkPayment();
      }, 3000);
    },

    stopPaymentCheck() {
      if (this.timer) {
        clearInterval(this.timer);
        this.timer = null;
      }
      this.isCheckingPayment = false;
      this.paymentCheckStartTime = null;
    },

    checkPayment() {
      const currentTime = Date.now();
      const elapsedTime = currentTime - this.paymentCheckStartTime;

      if (elapsedTime >= this.paymentTimeoutDuration) {
        this.handlePaymentTimeout();
        return;
      }

      const remainingTime = Math.ceil((this.paymentTimeoutDuration - elapsedTime) / 1000);
      this.message = `Waiting for payment... (${remainingTime}s remaining)`;

      const data = new FormData();
      data.append("function", "checkPayment");
      data.append("accountRef", this.paymentData.accNo);

      execute(data, biller)
          .then((res) => {
            if (res.data.success) {
              this.handlePaymentSuccess(res);
            }
          })
          .catch((e) => {
            console.error("Payment check error:", e.message);
          });
    },

    handlePaymentSuccess(res) {
      this.message = null;
      this.stopPaymentCheck();
      this.receipt = true;
      this.paymentData.success = false;
      this.transaction = res.data.data.transaction;
      this.receiptDetails = res.data.data.receipt.receiptDetails;

      this.transactionSummary = false;
      this.transactionCompleted = true;
    },

    handlePaymentTimeout() {
      this.stopPaymentCheck();
      this.message = "Payment check timed out. Please check your payment status manually or try again.";
    },

    getTradeCategory() {
      this.message = null
      const data = new FormData();
      data.append("function", "getIncomeTypes");
      data.append("incomeTypePrefix", "SBP");
      execute(data, biller)
          .then((res) => {
            if (res.data.success) {
              this.trade.tradeCategories = res.data.data.incomeTypes
            } else {
              this.message = res.data.message
            }
          })
          .catch((e) => {
            this.message = e.message
          });
    },

    getYears() {
      const data = new FormData();
      data.append("function", "getYears");
      execute(data, biller)
          .then((res) => {
            if (res.data.success) {
              this.years = res.data.data.years
            } else {
              this.message = res.data.message
            }
          })
          .catch((e) => {
            this.message = e.message
          });
    },

    getTradeSubCategory(event) {
      this.message = null
      const data = new FormData();
      this.trade.businessDetails.incomeTypeID = event.target.value
      data.append("function", "getFeesAndCharges");
      data.append("incomeTypeId", event.target.value);
      execute(data, biller)
          .then((res) => {
            if (res.data.success) {
              this.trade.tradeSubCategories = res.data.data.feesAndCharges
            } else {
              this.message = res.data.message
            }
          })
          .catch((e) => {
            this.message = e.message
          });
    },

    selectedTradeSubCategory(event) {
      const data = JSON.parse(event.target.value)
      this.trade.businessDetails.businessCategory = data.accountDesc
      this.trade.businessDetails.businessSubCategory = data.feeDescription
      this.trade.amount = data.unitFeeAmount
      this.trade.businessDetails.feeID = data.feeId;

      this.selectedFeeAndCharge(event)
    },

    getTradeCategoryOther(forceAll = false) {
      // Mirrors TopUpModal._loadOtherChargesByPrefix: first try the narrow
      // SBP+Other filter; if that returns 0 income types, retry with NO
      // params at all so the officer sees the full set of fees across every
      // income type (Penalty, Health, Fire, etc.). Previously this fallback
      // kept incomeTypePrefix=SBP, which is narrower than TopUpModal —
      // hence the mismatch the user reported.
      const data = new FormData();
      data.append("function", "getIncomeTypes");

      if (!forceAll) {
        data.append("incomeTypePrefix", "SBP");
        data.append("keyword", "Other");
      }

      execute(data, biller)
          .then((res) => {
            const hasData = res.data.success && res.data.data && res.data.data.incomeTypes;
            const incomeTypes = hasData ? res.data.data.incomeTypes : [];

            if (incomeTypes.length === 0 && !forceAll) {
              this.showAllCharges = true;
              this.message = 'No filtered categories found. Loading all available categories...';
              setTimeout(() => { this.message = null; }, 3000);
              this.getTradeCategoryOther(true);
              return;
            }

            if (incomeTypes.length > 0) {
              this.otherChargeCategories = incomeTypes;
              if (this.message && this.message.includes('filtered categories')) {
                this.message = null;
              }
              this.tradeSubCategoriesOther = [];

              // Eagerly pull fees for every "Other" income type and merge
              // them into a flat list. Same shape as the Android app's
              // loadFeesAsCheckboxes path — gives the officer a single
              // ready-to-pick dropdown without a 2-step category click.
              this.preloadAllOtherFees(incomeTypes);
            } else {
              this.message = 'No additional charge categories available';
              this.otherChargeCategories = [];
              this.tradeAllOtherFees = [];
            }
          })
          .catch((e) => {
            this.message = e.message;
          });
    },

    preloadAllOtherFees(incomeTypes) {
      this.tradeAllOtherFees = [];
      const fetches = incomeTypes.map((t) => {
        const fd = new FormData();
        fd.append('function', 'getFeesAndCharges');
        fd.append('incomeTypeId', t.incomeTypeId);
        return execute(fd, biller)
            .then((r) => {
              if (!(r.data && r.data.success)) return [];
              const list = (r.data.data && r.data.data.feesAndCharges) || [];
              return list.map((f) => ({
                ...f,
                _incomeTypeId: t.incomeTypeId,
                _incomeTypeDescription: t.incomeTypeDescription
              }));
            })
            .catch(() => []);
      });
      Promise.all(fetches).then((arrays) => {
        this.tradeAllOtherFees = arrays.reduce((acc, arr) => acc.concat(arr), []);
      });
    },

    handleOtherCategorySelected(category) {
      if (category && category.incomeTypeId) {
        this.getTradeSubCategoryOther(category.incomeTypeId);
      } else {
        this.tradeSubCategoriesOther = [];
      }
    },

    handleOtherChargesUpdated(charges) {
      this.totalFeeAmountOthers = charges.reduce((total, item) => {
        return total + (item.unitFeeAmount * item.quantity);
      }, 0);
      this.checkedItems = charges;
    },

    toggleChargesView() {
      this.showAllCharges = !this.showAllCharges;
      this.getTradeCategoryOther(this.showAllCharges);
    },

    getTradeSubCategoryOther(incomeTypeId) {
      this.tradeSubCategoriesOther.splice(0);
      const data = new FormData();
      data.append("function", "getFeesAndCharges");
      data.append("incomeTypeId", incomeTypeId);

      execute(data, biller)
          .then((res) => {
            if (res.data.success) {
              this.tradeSubCategoriesOther = res.data.data.feesAndCharges;
            } else {
              this.message = res.data.message;
            }
          })
          .catch((e) => {
            this.message = e.message;
          });
    },

    getReconciledRecords(search) {
      this.alert.info = true
      this.alert.success = false
      this.alert.failed = false
      this.message = `searching...for ${search}`

      const data = new FormData();
      data.append("function", "getReconciledRecords");
      data.append("page", this.currentPage);
      data.append("rows_per_page", this.pageSize);
      data.append("search", search);
      data.append("preciseSearch", true);

      execute(data, biller)
          .then((res) => {
            this.message = res.data.message
            this.alert.info = false
            if (res.data.success) {
              this.alert.success = true
              this.ReconTransactions = res.data.data.ReconTransactions
              this.message = `${this.ReconTransactions[0].description} | KES ${this.ReconTransactions[0].amount} | ${this.ReconTransactions[0].date} | ${this.ReconTransactions[0].transactionCode}`
            } else {
              this.alert.failed = true
            }
          })
          .catch((e) => {
            this.message = e.message
          });
    },

    getFloor() {
      const data = new FormData();
      data.append("function", "getFloor");
      execute(data, trade)
          .then((res) => {
            if (res.data.success) {
              this.trade.floors = res.data.data.floors
            } else {
              this.message = res.data.message
            }
          })
          .catch((e) => {
            this.message = e.message
          });
    },

    getTonnage() {
      const data = new FormData();
      data.append("function", "getTonnage");
      execute(data, trade)
          .then((res) => {
            if (res.data.success) {
              this.trade.tonnage = res.data.data.tonnage
            } else {
              this.message = res.data.message
            }
          })
          .catch((e) => {
            this.message = e.message
          });
    },

    getRoles() {
      const data = new FormData();
      data.append("function", "getRoles");
      execute(data, trade)
          .then((res) => {
            if (res.data.success) {
              this.roles = res.data.data.roles
            } else {
              this.message = res.data.message
            }
          })
          .catch((e) => {
            this.message = e.message
          });
    }
  }
}
</script>

<style scoped>
.bill-creater-module {
  min-height: 500px;
}

.invoice-form {
  background: #f8f9fa;
  border-radius: 8px;
}

.invoice-table {
  background: #f8f9fa;
  border-radius: 8px;
}

.the-bill-item {
  font-size: 14px;
  line-height: 1.5;
}
</style>